module.exports = __webpack_public_path__ + "static/media/icon-image-crop-zoom-out.21179762.svg";